<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.gradient-text-one {
  background-image: -webkit-linear-gradient(#85fdff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;border: 1px #636363 solid;" :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#202027' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;border-bottom: 1px #636363 solid;padding: 10px;" :style="{ 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC' }">
      <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
        <p class="gradient-text-one" style="font-size: 18px;font-weight: 600;line-height: 22px;">
          {{ $t("kaijilvzuigao") }}
        </p>
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <div style="padding: 16px;display: flex;flex-direction: column;justify-content: space-around;height: 100%;">
        <div style="display: flex;width:100%;align-items: center;height: 100%;">
          <div style="flex-shrink: 0;display: flex;flex-direction: column;justify-content: space-between;height: 100%;max-width: 80px;overflow: hidden;;">
            <div v-for="(rate, i) in lists" style="flex-shrink: 0;color:white;font-size: 14px;overflow: hidden;font-weight: 600;height: 19px;">{{ rate.equipmentName }}</div>
          </div>
          <div style="flex: 1;display: flex;flex-direction: column;justify-content: space-between;height: 100%;">
            <div v-for="(rate, i) in lists" style="height: 19px;display: flex;align-items: center;;">
              <div style="height:10px;border-radius: 6px;background: #43434D;margin: 0 6px;width: 100%">
                <div style="height: 10px;border-radius: 6px;" :style="{ 'background-color': ['#3BB9FF', '#FF4EA3', '#EFFF3B', '#67E265', '#913BFF'][i], width: rate.startupRate + '%' }"></div>
              </div>
            </div>
          </div>
          <div style="flex-shrink: 0;display: flex;flex-direction: column;justify-content: space-between;height: 100%;">
            <div v-for="(rate, i) in lists" style="flex-shrink: 0;color:white;font-size: 14px;font-weight: 600;height: 19px;">{{ rate.startupRate }}%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_manufacturing_uprate",
  components: {},
  watch: {
    "$attrs.orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    },
  },
  data() {
    return {
      timer: null,
      contentHeight: 0,
      lists: [],
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 300000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get("/web/report/page/zhinengzhizao_jinniankaijilvzuigao?getOrgByParent=orgId", {
        params: {
          pageSize: 5,
          orgId: this.$attrs.orgId,
        },
      });
      this.lists = response.data.rows;
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight;
      }, 800);
    },
  },
};
</script>
